import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_LISTING_GET_WEEKLY_LEADS } from 'api/actionTypes';

export default async function getWeeklyLeads({ state, apiClient }, { listingId, reload = false }) {
  typeCheck('listingId::PositiveNumber', listingId);
  const statePath = ['listings', 'weeklyLeads', listingId];

  if (state.exists(statePath) && !reload) {
    return state.get(statePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_LISTING_GET_WEEKLY_LEADS,
    state: state,
    queryId: `${listingId}`,
    payload: {
      listingId,
    },
    onSuccess(should) {
      state.set(statePath, should);
    },
  });
}
